import React from 'react';
import { DataGridRow, DataColumnHeader, DataGridHeaderRow, Loader } from '../components';

class DataGrid extends React.Component {

    renderRow(data, i) {
        return (
            <DataGridRow key={i}>
                { this.renderChildrenForRow(data) }
            </DataGridRow>
        )
    }

    renderChildrenForRow(rowData) {
        return React.Children.map(this.props.children, (child, i) => {
            let data = rowData[child.props.columnName];
            return React.cloneElement(child, {
                data: data,
                rowData: rowData,
                key: i
            });
        })
    }

    renderHeaders() {
        return (
            <DataGridHeaderRow>
                {
                    React.Children.map(this.props.children, (child, i) => {
                        return (
                            <DataColumnHeader key={i} text={child.props.displayName} headerComponent={child.props.headerComponent} />
                        )
                    })
                }
            </DataGridHeaderRow>
        )
    }

    renderEmpty() {
        let empty = (
            <div className="data-placeholder-empty">
                <h3>No results.</h3>
            </div>
        );

        if (this.props.emptyPlaceholder) {
            empty = this.props.emptyPlaceholder;
        }

        return (
            <div className="empty-grid" colspan="99999">
                { empty }
            </div>
        )
    }

    renderLoading() {
        return (
            <Loader />
        )
    }

    renderData(data = []) {
        if (this.props.isLoading) {
            return null;
        }
        return data.map((rowData, i) => {
            return this.renderRow(rowData, i);
        });
    }

    render () {
        let data = this.props.data || [];
        let empty = (data.length < 1) ? this.renderEmpty() : null;
        if (this.props.isLoading) {
            empty = this.props.loadingPlaceholder || this.renderLoading();
        }

        return (
            <div {...this.props} className={['component-data-grid', this.props.className].join(' ')}>
                <div className="data-grid">
                    {
                        this.renderHeaders()
                    }
                    {
                        this.renderData(data)
                    }
                </div>
                { empty }
            </div>
        )
    }
}

export default DataGrid;



// WEBPACK FOOTER //
// ./web-app/components/data-grid.jsx